import BetaPluginSetup from "./beta/PluginSetup.js";
import AboutLink from "./AboutLink.js";
import AccountRoute from "./AccountRoute.js";
import DesktopAccountLink from "./DesktopAccountLink.js";
import MobileAccountLink from "./MobileAccountLink.js";
import DesktopIntercomLink from "./DesktopIntercomLink.js";
import MobileIntercomLink from "./MobileIntercomLink.js";
import DesktopPersonaLinks from "./DesktopPersonaLinks.js";
import MobilePersonaLinks from "./MobilePersonaLinks.js";
import DesktopTermsAndConditions from "./DesktopTermsAndConditions.js";
import MobileTermsAndConditions from "./MobileTermsAndConditions.js";
import HelpCenterLink from "./HelpCenterLink.js";
export default {
  install(molten) {
    BetaPluginSetup.install(molten);
    molten.addPlugin('Action', AboutLink);
    molten.addPlugin('Route', AccountRoute);
    molten.addPlugin('Action', DesktopAccountLink);
    molten.addPlugin('Action', MobileAccountLink);
    molten.addPlugin('Action', DesktopIntercomLink);
    molten.addPlugin('Action', MobileIntercomLink);
    molten.addPlugin('Action', DesktopPersonaLinks);
    molten.addPlugin('Action', MobilePersonaLinks);
    molten.addPlugin('Action', DesktopTermsAndConditions);
    molten.addPlugin('Action', MobileTermsAndConditions);
    molten.addPlugin('Action', HelpCenterLink);
  }
};